import { Component } from 'react'
import Slider from 'react-slick'
import { Glyphicon } from 'react-bootstrap'
import styled, { css } from 'styled-components'

const Container = styled.div`
  margin: 0 25px;
`
const StyledArrow = styled.button`
  top: 50%;
  width: 20px;
  height: 20px;
  background: none;
  cursor: pointer;
  border: none;
  outline: 0;
  right: ${(props) => (props.right ? '-25px' : 'auto')};
  left: ${(props) => (props.right ? 'auto' : '-25px')};
  position: absolute;
  display: block;
  padding: 0;
  font-size: 16px;
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.2;
    `}
`

const NextArrow = (props) => (
  <StyledArrow onClick={props.onClick} right disabled={!props.onClick}>
    <Glyphicon glyph="chevron-right" />
  </StyledArrow>
)

const PrevArrow = (props) => (
  <StyledArrow onClick={props.onClick} disabled={!props.onClick}>
    <Glyphicon glyph="chevron-left" />
  </StyledArrow>
)

class WrappedSlider extends Component {
  componentDidMount() {
    if (this.props.currentSlide) {
      setTimeout(() => {
        this.refs.slider.slickGoTo(this.props.currentSlide - 1)
      }, 0)
    }
  }

  render() {
    const settings = {
      arrows: true,
      dots: false,
      infinite: false,
      speed: 350,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: false,
      draggable: false,
      className: 'custom-slider',
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    }

    return (
      <Container>
        <Slider ref="slider" {...settings} {...this.props.settings}>
          {this.props.children}
        </Slider>
      </Container>
    )
  }
}

export default WrappedSlider
